export default function mapQueryResponse(queryResponse) {
  return Object.keys(queryResponse).reduce((acc, curr) => {
    let mappedObj = {};
    if (typeof queryResponse[curr] === 'object' && queryResponse[curr] !== null) {
      if (queryResponse[curr]?.data) {
        if (Array.isArray(queryResponse[curr]?.data)) {
          const mapped = queryResponse[curr].data.map((el) => mapQueryResponse(el.attributes));
          return { ...acc, [curr]: [...mapped] };
        }
        mappedObj = mapQueryResponse(queryResponse[curr].data.attributes);
        return { ...acc, [curr]: mappedObj };
      }
      mappedObj = mapQueryResponse(queryResponse[curr]);
      return { ...acc, [curr]: mappedObj };
    }
    return { ...acc, [curr]: queryResponse[curr] };
  }, {});
}
